"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Label = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)("label", __assign({ "data-sr-input-label": true }, rest, { children: children })));
};
var Input = function (_a) {
    var name = _a.name, label = _a.label, id = _a.id, rest = __rest(_a, ["name", "label", "id"]);
    var required = rest.required;
    return ((0, jsx_runtime_1.jsxs)("div", { "data-sr-input-wrapper": true, children: [(0, jsx_runtime_1.jsxs)(Label, { htmlFor: id, children: [label, required && ((0, jsx_runtime_1.jsx)("abbr", { title: "required", "data-sr-input-asterisk": true, children: "*" }))] }), (0, jsx_runtime_1.jsx)("input", __assign({ "data-sr-input": true, name: name, id: id }, rest))] }));
};
exports.default = Input;
